import(/* webpackMode: "eager" */ "/home/vsts/work/r1/a/_Whimstay-travel-agent/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/r1/a/_Whimstay-travel-agent/node_modules/next/dist/client/image-component.js");
